import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useExitDispatcher = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);

    const onExitDispatcherError = (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(
            err?.response?.data?.message ?? 'Something went wrong while exiting drivers.',
        );
    };

    const onExitDispatcherSuccess = (callback: () => void) => ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        callback();
    };

    const exitDispatcher = (data: any, driverId: string, callback: () => void) => {
        const url: HttpConfig = {
            url: `api/v1/dispatchers/${driverId}/exit`,
            method: 'delete',
            data: data
        };

        request(url, onExitDispatcherSuccess(callback), setLoading, onExitDispatcherError);
    };

    return { exitDispatcher, loading };
};

export default useExitDispatcher;
